import {useState} from 'react';
import ReactMapGL, {Popup, Source, Layer} from 'react-map-gl';
import Pins from './Pins';
import CityInfo from './CityInfo';
import CITIES from './cities.json';

const REACT_APP_MAPBOX_ACCESS_TOKEN = 'pk.eyJ1IjoiYnJhZGxleWJvc3NhcmR1ZiIsImEiOiJja3NoeWR2ODkxemFoMnBwYTM1emhhYmU4In0.etmCrrx1r0vece_U8jvwFw';

function Map(props) {
  const {sideLength, cityName} = props;

  const [viewport, setViewport] = useState({
    latitude: 37.7577,
    longitude: -102.4376,
    zoom: 3 
  });

  const [popupInfo, setPopupInfo] = useState(null);

  const halfSideLength = sideLength / 2.0;
 
  const latitudes = CITIES.map(city => city.latitude);
  const longitudes = CITIES.map(city => city.longitude);
  const minLat = Math.min(...latitudes);
  const maxLat = Math.max(...latitudes);
  const minLng = Math.min(...longitudes);
  const maxLng = Math.max(...longitudes);
  const centerLat = (maxLat + minLat) / 2.0;
  const centerLng = (maxLng + minLng) / 2.0;

  const minLatBound = Math.min(centerLat - halfSideLength, centerLat + halfSideLength);
  const maxLatBound = Math.max(centerLat - halfSideLength, centerLat + halfSideLength);
  const minLngBound = Math.min(centerLng - halfSideLength, centerLng + halfSideLength);
  const maxLngBound = Math.max(centerLng - halfSideLength, centerLng + halfSideLength);

  const filteredCities = CITIES.filter(city => {
    const isInBounds =
      city.latitude > minLatBound &&
		  city.latitude < maxLatBound &&
      city.longitude > minLngBound &&
      city.longitude < maxLngBound;
    const matchesCityName = cityName === '' ? true : city.name.toLowerCase().includes(cityName.toLowerCase());
    return isInBounds && matchesCityName;
  })

  const geojson = {
    type: "FeatureCollection",
    features: [
      {
        type: "Feature",
        properties: {},
        geometry: {
          type: "Polygon",
          coordinates: [
            [
              [
                minLngBound,
                maxLatBound 
              ],
              [
                maxLngBound,
                maxLatBound 
              ],
              [
                maxLngBound,
                minLatBound 
              ],
              [
                minLngBound,
                minLatBound 
              ],
              [
                minLngBound,
                maxLatBound 
              ]
            ]
          ]
        }
      }
    ]
  };
  
  const layerStyle = {
    id: 'outline',
    type: 'line',
    paint: {
      'line-color': '#007cbf',
      'line-width': 3
    }
  };

  return (
      <ReactMapGL
        {...viewport}
        mapStyle="mapbox://styles/mapbox/dark-v9"
        width="100vw"
        height="100vh"
        mapboxApiAccessToken={REACT_APP_MAPBOX_ACCESS_TOKEN}
        onViewportChange={(viewport) => setViewport(viewport)}
      >

      <Pins data={filteredCities} onClick={setPopupInfo} />

      <Source id="my-data" type="geojson" data={geojson}>
        <Layer {...layerStyle} />
      </Source>

      {popupInfo && (

        <Popup
          tipSize={5}
          anchor="top"
          longitude={popupInfo.longitude}
          latitude={popupInfo.latitude}
          closeOnClick={false}
          onClose={setPopupInfo}
        >
          <CityInfo info={popupInfo} />
        </Popup>
      )}
      </ReactMapGL>
  );
 }

 export default Map;